import { select } from "d3-selection";
import { dispatch } from "d3-dispatch";
import JQuery from "jquery";

export default selector => {
  let data = [];
  const dispatchEvent = dispatch("shown", "hidden");

  const $ = () => {
    const selection = select(selector);

    const container = selection
      .append("div")
      .attr("class", "step vh-100 w-100 with-navbar homeRisks")
      .append("div")
      .attr("class", "container h-100")
      .append("div")
      .attr("class", "row h-100");

    const isoContainer = container
      .append("div")
      .attr("class", "col-12 col-md-8 position-relative px-0 h-100");

    const riskBg = isoContainer
      .append("img")
      .attr("class", "risksBg")
      .style("filter", "grayscale(0)")
      .style("opacity", "1")
      .attr(
        "src",
        "http://www.optics-project.eu/wp-content/uploads/2019/03/landscape_neutro_risks_20190325.png"
      );

    const risksContainer = container
      .append("div")
      .attr("class", "col-12 col-md-4 h-100")
      .style("overflow-y", "auto");

    risksContainer
      .append("h6")
      .attr("class", "risks-label")
      .text("key risk areas");

    const accordion = risksContainer
      .append("div")
      .attr("class", "accordion")
      .attr("id", "accordionRisks");

    const cards = accordion.selectAll(".card").data(data, function(d) {
      return d.step;
    });

    const card = cards
      .enter()
      .append("div")
      .attr("class", "card");

    const cardHeader = card
      .append("div")
      .attr("class", "card-header")
      .attr("id", function(d, i) {
        return "heading_" + d.step;
      })
      .attr("data-toggle", "collapse")
      .attr("data-target", function(d, i) {
        return "#collapse_" + d.step;
      });

    cardHeader
      .append("div")
      .attr("class", "risk-number")
      .text(function(d, i) {
        return i + 1;
      });

    cardHeader
      .append("div")
      .attr("class", "risk-title collapsed")
      .text(function(d) {
        return d.title;
      });

    cardHeader.append("i").attr("class", "material-icons ml-auto");

    const cardBody = card
      .append("div")
      .attr("class", "collapse")
      .attr("id", function(d, i) {
        return "collapse_" + d.step;
      })
      .attr("data-parent", "#accordionRisks")
      .append("div")
      .attr("class", "card-body");

    cardBody.append("p").text(function(d) {
      return d.desc;
    });

    cardBody
      .append("p")
      .attr("class", "text-black-50")
      .text(function(d) {
        return d.detail;
      });

    JQuery("#accordionRisks")
      .on("hidden.bs.collapse", function() {
        dispatchEvent.call("hidden");
        isoContainer.select(".overlay").remove();
        riskBg
          .transition()
          .style("filter", "grayscale(0)")
          .style("opacity", "1");
      })
      .on("shown.bs.collapse", function() {
        const info = accordion.select(".collapse.show").data();
        dispatchEvent.call("shown", this, info[0]);
        riskBg
          .transition()
          .style("filter", "grayscale(1)")
          .style("opacity", "0.25");
        isoContainer
          .append("img")
          .attr("class", "overlay")
          .attr("src", info[0].img_url);
      });
  };

  $.data = _ => {
    data = _;
    return $;
  };

  $.on = function() {
    var value = dispatchEvent.on.apply(dispatchEvent, arguments);
    return value === dispatchEvent ? $ : value;
  };

  return $;
};
